import { createContext, PropsWithChildren, useCallback, useContext, useState } from 'react'
import { IPopup, PopupType } from './Popup'

export interface PopupContext {
  popups: IPopup[]
  pushPopup: (value: string, type?: PopupType) => void
  hidePopup: (id: string) => void
}

const POPUP_DURATION = 3000

const MAX_POPUP_COUNT = 3

const PopupContext = createContext<PopupContext | null>(null)

export const PopupProvider = ({ children }: PropsWithChildren) => {
  const [popups, setPopups] = useState<IPopup[]>([])

  const pushPopup = useCallback((text: string, type: PopupType = PopupType.Info) => {
    const newPopup = {
      id: Math.random().toString(36),
      text,
      type,
      visible: true,
      created: Date.now(),
    }

    setPopups((current) => [...current, newPopup].slice(-MAX_POPUP_COUNT))

    setTimeout(() => {
      setPopups((current) => current.filter((p) => p !== newPopup))
    }, POPUP_DURATION)
  }, [])

  const hidePopup = useCallback((id: string) => {
    setPopups((current) => current.filter((p) => p.id !== id))
  }, [])

  return <PopupContext.Provider value={{ popups, pushPopup, hidePopup }}>{children}</PopupContext.Provider>
}

export const usePopup = () => useContext(PopupContext)
